export const TRADES_BLOTTER_PREFIX = 'principal/trades';
export const TRADES_MULTILEG_VIEW_CONTAINER_ID = 'tradesMultilegViewContainer';
